import { render, staticRenderFns } from "./credits-history.vue?vue&type=template&id=5f7cc142&lang=pug&"
import script from "./credits-history.vue?vue&type=script&lang=js&"
export * from "./credits-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports